export default {
    getFullAddress: function (address) {
        if (!address) return;
        let fullAddress = '';

        if (!address.strAddress) {
            fullAddress += `${address.address} `;
            fullAddress += `${address.number} `;
            fullAddress += `${address.moo} `;
            fullAddress += `${address.village} `;
            fullAddress += `${address.building} `;
            fullAddress += `${address.room} `;
            fullAddress += `${address.floor} `;
            fullAddress += `${address.soi} `;
            fullAddress += `${address.road} `;
        } else {
            fullAddress += `${address.fullAddress}`;
        }

        fullAddress += `${address.subDistrictName} `;
        fullAddress += `${address.districtName} `;
        fullAddress += `${address.provinceName} `;
        fullAddress += `${address.zipcode} `;

        return fullAddress.trim();
    }
}
